import { trackEvent } from '@farmnet/tag-manager';

angular.module('cfn').controller('adminController', [
  '$scope',
  function($scope) {
    $scope.hasModule = app.hasModule;

    $scope.hasRight = app.hasRight;

    $scope.trackSettingsNavigation = (title) => {
      const navigationLabel = `Settings::${title}`;

      trackEvent('Navigation', 'Body', navigationLabel);
    };

    return ($scope.adminController = this);
  }
]);
